export enum Generic {
    SMALL = "small",
    LARGE = "large"
}
